import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../../Common/helper/helpar";

export const ExportLoadingEquipmentInnerCertification = ({ data, row }) => {
  const downloadExcel = async () => {
    // Get current date/time for header
    console.log(data, "data");
    
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      data?.startDate && data?.endDate ? `(${formatDateTimeWithoutSec(data?.startDate)} to ${formatDateTimeWithoutSec(data?.endDate)})` : "";
    // Determine report type based on the "circle" flag
    console.log(filterDateRange, "filterDateRange")
    const reportTitle = `Loading Equipment Certification Summary as on ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    // Merge cells across 10 columns (adjust if needed)
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 10);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle,]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 10);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Shift",
      "Loading Equipment Number",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity",
      "Start Shift Date & Time",
      "First GVP Start Time",
      "Last GVP End Time",
      "End Shift Date & Time",
      "Total Shift Hours",
      "Certified Worked Hrs.",
      "Certified Intransit /Idle Hrs.",
      "Certified Total Hrs.",
      "Deduct BreakDown Hrs.",
      "Deduct Late Reporting",
      "Deduct Early Leaving",
      "Deduct Total Hrs.",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    row.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.zoneName?? "N/A",
        item.circleName?? "N/A",
        item.shift?? "N/A",
        item.loadingEquipmentNumber?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.ownerType?? "N/A",
       item.vehicleCapacityName?? "N/A",
        item.startShiftDate?? "N/A",
        item.firstGVPStartTime?? "N/A",
        item.lastGVPEndTime?? "N/A",
        item.endShiftDateTime?? "N/A",
        item.totalShiftHours?? "N/A",
        item.certifiedWorkedHours?? "N/A",
        item.certifiedIntransitHours?? "N/A",
        item.certifiedTotalHours?? "N/A",
        item.deductBreakdownHours?? "N/A",
        item.deductLateReportHours?? "N/A",
        item.deductEarlyLeaveHours?? "N/A",
        item.deductTotalHours?? "N/A",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "LoadingEquipmentCertificationSummary.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <button
      type="reset"
      className="btn btn-excel"
      onClick={downloadExcel}
    >
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
  )
}